import { postOffers } from '../api/postOffers';

export const setPostOffers = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            await postOffers(params);

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}